$(document).ready(function () {
  const $headerWrapper = $(".header-wrapper");
  const $logo = $(".header__heading-logo");

  $(window).on("scroll", function () {
    if ($(this).scrollTop() > 50) {
      if (!$headerWrapper.hasClass("scrolled")) {
        $headerWrapper.addClass("scrolled");

        const stickyLogoSrc = $logo.attr("sticky-logo");
        if (stickyLogoSrc) {
          // $logo.attr('src', stickyLogoSrc);
          $logo.attr(
            "srcset",
            `${stickyLogoSrc} 70w, ${stickyLogoSrc} 105w, ${stickyLogoSrc} 140w`
          );
        }
      }
    } else {
      if ($headerWrapper.hasClass("scrolled")) {
        $headerWrapper.removeClass("scrolled");

        const originalSrc = $logo.attr("src")?.split(",")[0]?.split(" ")[0];
        if (originalSrc) {
          // $logo.attr('src', originalSrc);
          $logo.attr(
            "srcset",
            `${originalSrc} 70w, ${originalSrc} 105w, ${originalSrc} 140w`
          );
        }
      }
    }
  });

  // ================================ Combo Product Ajax ===========================

  $(
    ".combo_product_desktop .combo_btn button, .combo_product_mobile .combo_btn button"
  ).click(function () {
    var combo_prd_array = [];
    $(this)
      .parents(".combo_product_desktop")
      .find(".combo_prd_col")
      .each(function () {
        var variant_ids = $(this).attr("data-variant-id");
        combo_prd_array.push({ id: variant_ids, quantity: 1 });
      });
    $(this)
      .parents(".combo_product_mobile")
      .find(".combo_prd_col")
      .each(function () {
        var variant_ids = $(this).attr("data-variant-id");
        combo_prd_array.push({ id: variant_ids, quantity: 1 });
      });

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        items: combo_prd_array,
      },
      dataType: "json",
      success: function () {
        window.location.href = "/cart";
      },
    });
  });
});

// $(document).ready(function () {
//   if (window.innerWidth <= 768) {
//     $(".new_multicolumn_container .multicolumn-list").slick({
//       infinite: true,
//       slidesToShow: 1,
//       slidesToScroll: 1,
//     });
//   }
// });
